import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE NUTRITIONIST’S VAULT™',
  ideal: 'Anyone wishing to manage a professional nutrition practice from scratch or optimize an existing one',
  was: '$38',
  now: '19',
  features: ['6 Complete Volumes (120+ pages)', 'Clinical, Assessment and Planning protocols', 'Real patient retention frameworks', '30-Day routine with visible practice growth', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The Nutritionist’s Vault™'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-130" data-mp="3vzp6pldb6gal">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-131" data-mp="4svttk95ksq8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(15,122,82,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-132" data-mp="9rp6jagm8fpc">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-133" data-mp="3n5txa155m3p5">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-134" data-mp="3rzeptdnza5gy">
            <span className="font-semibold text-plum/80" data-id="element-135" data-mp="2uipnzjz1337k">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-136" data-mp="2zhapdmq0nsxl">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-137" data-mp="2zg9epjcwx8ge">{plan.was}</span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "20px",
            paddingBottom: "26px"
          }} data-id="element-138" data-mp="2res3mc9xz70k">
              <span className="relative inline-block font-display font-black leading-none" data-id="element-139" data-mp="316ehkgdnzk70">
                {/* Currency symbol — edit its size here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 pr-1.5 font-display font-black leading-none" style={{
                fontSize: "44px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-140" data-mp="2w8d1837mhyz8">
                  $
                </span>
                {/* Amount — edit its size here */}
                <span className="text-grape-shine font-display font-black leading-none" style={{
                fontSize: "72px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-141" data-mp="2ihhmiaag0nnq">
                  {plan.now}
                </span>
                {/* Currency code — edit its size here */}
                <span className="text-grape-shine absolute left-full top-1/2 -translate-y-1/2 pl-1.5 font-display font-black leading-none" style={{
                fontSize: "26px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-142" data-mp="3ov7as52wjdxx">
                  USD
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-143" data-mp="3nfv01yqafpk3">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-144" data-mp="3rgyimszpzzp0">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-145" data-mp="o07x15rnne27">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-146" data-mp="a931aerer5x5">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-147" data-mp="e9wspi4272us" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-148" data-mp="11y69g5mf10f2">
            <CTAButton size="md" data-id="element-149" data-mp="16qzeyvppkcs7">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-150" data-mp="16saj4wn2fmju">
            You save $19 USD (50% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-151" data-mp="3a85y3o6girlz">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-152" data-mp="3180pjapj1n68">
                <Icon className="h-4 w-4 text-grape" data-id="element-153" data-mp="31a3ponke8woo" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-154" data-mp="3syf293lt0tgb" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-155" data-mp="3t08a2m85ljpw">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-156" data-mp="3k6lfgzfommia" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-157" data-mp="3k6d3ravapn8o">
            <span className="font-display font-bold text-plum" data-id="element-158" data-mp="kk588x3q2p9h">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not match what you need or does not
            give you the boost you were looking for, request your refund and we return 100% of your
            money. We want you to grow your practice with peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}